import type { Control, FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import type { HfDynamicFieldComponentProps } from '../../dynamic-form/dynamic-form.interfaces';
import GrandScore from './grand-score.component';

interface GrandScoreValue {
  totalScore: number;
  maxPossible: number;
  percentage: string;
}

export interface HfGrandScoreProps extends HfDynamicFieldComponentProps<GrandScoreValue> {
  control: Control<FieldValues>;
}

export default function HfGrandScore({ control, label, name, readOnly, labelStyles }: HfGrandScoreProps) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value } }) => (
        <GrandScore
          label={label}
          readOnly={readOnly}
          totalScore={value?.totalScore}
          maxPossible={value?.maxPossible}
          percentage={value?.percentage}
          labelStyles={labelStyles}
        />
      )}
    />
  );
}
